import React from 'react'
import {
  Box,
  Button,
  Typography, 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton, 
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VerifiedUserSharpIcon from "@mui/icons-material/VerifiedUserSharp";

const ConfirmationFinalModal = ({ isConfirmationFLOpen, setIsConfirmationFLOpen, setIsUploadMediaOpen,setIsNoConfirmationFLOpen }: { isConfirmationFLOpen: boolean; setIsConfirmationFLOpen: (open: boolean) => void; setIsUploadMediaOpen: (open: boolean) => void; setIsNoConfirmationFLOpen: (open: boolean) => void; }) => {
    const handleYesClick = () => {
        setIsConfirmationFLOpen(false);
        setIsUploadMediaOpen(true);
    };

    const handleNoClick = () => {
        setIsConfirmationFLOpen(false);
        setIsNoConfirmationFLOpen(true);
    };

    return (
        < >
            <Dialog
                open={isConfirmationFLOpen}
                onClose={() => setIsConfirmationFLOpen(false)}
                maxWidth={false}
                fullWidth={false}
                sx={{
                    "& .MuiDialog-paper": {
                        width: "350px",
                        maxWidth: "350px"
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 600,
                        fontSize: "1.1rem",
                        position: "relative",
                        pb: 1
                    }}
                >
                    Confirmation
                    <IconButton
                        aria-label="close"
                        onClick={() => setIsConfirmationFLOpen(false)}
                        sx={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent
                    dividers
                    sx={{
                        borderBottom: "none", // removes bottom line
                        borderTop: "1px solid rgba(0, 0, 0, 0.12)" // keep only top line
                    }}>
                    {/* Green Shield Icon */}
                    <Box sx={{ display: "flex", justifyContent: "left", mb: 3 }}>
                        <VerifiedUserSharpIcon sx={{ fontSize: 64, color: "#43B864" }} />
                    </Box>

                    {/* Question Text */}
                    <Typography
                        sx={{
                            fontSize: "1.2rem",
                            fontWeight: 700, 
                            mb: 2
                        }}>
                        Is your Construction/ Rectification completed?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        sx={{
                            borderRadius: "24px",
                            backgroundColor: "#3A1C73",
                            textTransform: "none",
                            fontWeight: 500,
                            width: "120px",
                            marginBottom: 1,
                            "&:hover": { backgroundColor: "#2a145c" }
                        }}
                        onClick={handleYesClick}
                    >
                        Yes, Completed
                    </Button>
                    <Button
                        onClick={handleNoClick}
                        variant="outlined"
                        sx={{
                            borderRadius: "24px",
                            borderColor: "#3A1C73",
                            color: "#3A1C73",
                            textTransform: "none",
                            fontWeight: 500,
                            width: "50px",
                            marginRight: 2,
                            marginBottom: 1
                        }}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ConfirmationFinalModal